import { Box, CircularProgress, Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import { RoleIdText } from "./Atom"
import { useDispatch, useSelector } from "react-redux"
import AdminAPI from "../../../../../../../api/admin"
import { getTokenLocal } from "../../../../../../../helper/utils"
import { useNavigate } from "react-router-dom"
import { setCsmData } from "../../../../../../redux/slices/usersSlice"
import { useResponseHandle } from "../../../../../../hooks"

const adminAPI = new AdminAPI()
function CSMListTab({ group_sk }: any) {
  const token: any = getTokenLocal()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const allCsm = useSelector((state: any) => {
    return state.users.csmData
  })
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const fetchAllCsm = async () => {
    const response = await adminAPI.getAllCsm(token, group_sk)
    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      setIsLoading(false)
      if (result?.statusCode == 200) {
        dispatch(setCsmData(result?.data))
      }
    } else {
      navigate("/auth")
    }

    return result
  }

  useEffect(() => {
    allCsm.length == 0 && setIsLoading(true)
    fetchAllCsm()
  }, [group_sk])

  return (
    <>
      {!isLoading ? (
        allCsm.length > 0 ? (
          <Box
            sx={{
              width: "30%",
              height: "100%",
              border: "1px solid #E3E3E3",
            }}
          >
            {allCsm?.map((csm: any, itemIndex: any) => {
              return (
                <li
                  key={itemIndex}
                  style={{
                    listStyle: "none",
                    padding: "22px 20px",
                    fontSize: "14px",
                    color: "#000",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                    borderBottom: "1px solid #E5E5E5",
                  }}
                >
                  {csm?.name}
                  <RoleIdText>{csm.role_display_name}</RoleIdText>
                </li>
              )
            })}
          </Box>
        ) : (
          <Typography sx={{ padding: "2rem" }}>
            No Customer Success Managers assigned
          </Typography>
        )
      ) : (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            // border: "1px solid red"
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </>
  )
}

export default CSMListTab
